// Fixed, brand-neutral palette for ADMIN-facing screens.
//
// This is the single source of truth for the admin panel look. It is intentionally
// screen-agnostic (not tied to the Products subfolder) so any admin screen can import
// it. Unlike `THEME.COLORS` / `customColor` (which reflect each white-label client's
// customizable brand), these tokens are constant for every client — so the admin panel
// looks the same, neutral and professional, regardless of the client's brand colors.
//
// Highlight colors (blue / teal / purple) are the admin brand. Green and red are
// SEMANTIC only — reserved for success and error feedback, never for default buttons.
//
// Student-facing screens must keep using the client's colors — do NOT use this there.

export const ADMIN_COLORS = {
  // Highlights / accents
  accent: '#2B93ED', // primary (blue)
  accentDark: '#1C7FD6', // hover / pressed
  accentSoft: '#E7F2FD', // soft blue surface
  teal: '#01C3CC',
  tealDark: '#01A5AC', // hover / pressed do teal
  tealSoft: '#E6F8F9',
  purple: '#7B1DA5',

  // Text
  ink: '#1F2937', // dark gray — body / titles
  label: '#374151', // form labels
  muted: '#6B7280', // secondary text
  placeholder: '#9CA3AF', // light gray — input placeholders

  // Surfaces / lines
  border: '#E5E7EB',
  surface: '#FFFFFF',
  surfaceSubtle: '#F7F8FA',

  // Buttons
  // primaryBg é o TEAL, não o accent azul: é o fundo da ação principal na maior
  // parte do painel (ver `AdminButton` e docs/PADRAO-PAINEL-ADMIN.md). O accent
  // azul fica para seleção, foco e destaque de informação.
  primaryBg: '#01C3CC',
  primaryBgHover: '#01A5AC',
  primaryText: '#FFFFFF',
  secondaryBg: '#F3F4F6', // neutral cancel / secondary
  secondaryText: '#374151',

  // Semantic — success (green) : ONLY for success feedback
  success: '#059669',
  successSoft: '#ECFDF5',
  successBorder: '#A7F3D0',

  // Semantic — danger (red) : error feedback + destructive actions
  danger: '#DC2626',
  dangerSoft: '#FEF2F2',
  dangerBorder: '#FECACA',

  // Info banner (blue, aligned with accent)
  infoBg: '#E7F2FD',
  infoBorder: '#BBDDFB',
  infoText: '#1C7FD6',

  // Warning banner (amber)
  warnBg: '#FFF7ED',
  warnBorder: '#FED7AA',
  warnText: '#9A3412',

  radius: 12,
};

// Neutral system font for the admin panel — intentionally NOT the client's custom brand
// font, so the admin panel reads the same for every white-label client.
//
// IMPORTANT: keep this a SINGLE font token (no comma-separated stack). It is consumed by
// styled-components/native texts (Title/SubTitle/SmallText/... in globalStyles), whose
// css-to-react-native parser throws on multi-value font-family declarations — a comma
// list here crashes every admin screen that renders one of those texts. `system-ui`
// resolves to the OS font (Segoe UI on Windows, San Francisco on macOS, Roboto on Android).
export const ADMIN_FONT = 'system-ui';

export default ADMIN_COLORS;
